import MAKeySecurities from './MAKeySecurities'

export default MAKeySecurities
